import { defineComponent as _defineComponent } from 'vue';
import { library } from "@fortawesome/fontawesome-svg-core";
import { faTimes } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { BButton } from "bootstrap-vue";
import { storeToRefs } from "pinia";
import { computed, ref } from "vue";
import { useExtendedHistory } from "@/composables/detailedHistory";
import { useHistoryStore } from "@/stores/historyStore";
import HistoryNavigation from "../CurrentHistory/HistoryNavigation.vue";
import CollectionPanel from "@/components/History/CurrentCollection/CollectionPanel.vue";
import HistoryPanel from "@/components/History/CurrentHistory/HistoryPanel.vue";
import LoadingSpan from "@/components/LoadingSpan.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'MultipleViewItem',
    props: {
        source: null,
        filter: null
    },
    setup(__props) {
        const props = __props;
        library.add(faTimes);
        const historyStore = useHistoryStore();
        const { currentHistoryId, histories, historiesLoading, pinnedHistories } = storeToRefs(historyStore);
        const { history } = useExtendedHistory(props.source.id);
        const selectedCollections = ref([]);
        const sameToCurrent = computed(() => {
            return currentHistoryId.value === props.source.id;
        });
        function onViewCollection(collection) {
            selectedCollections.value = [...selectedCollections.value, collection];
        }
        return { __sfc: true, props, historyStore, currentHistoryId, histories, historiesLoading, pinnedHistories, history, selectedCollections, sameToCurrent, onViewCollection, faTimes, FontAwesomeIcon, BButton, HistoryNavigation, CollectionPanel, HistoryPanel, LoadingSpan };
    }
});
